import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9d26f76a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d26f76a')) {
      api.createRecord('9d26f76a', component.options)
    } else {
      api.reload('9d26f76a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=9d26f76a", function () {
      api.rerender('9d26f76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/logoSet/index.vue"
export default component.exports